module.exports = __webpack_public_path__ + "static/media/react.a03a8833.svg";